import React, { useEffect, useState } from "react";
import AuthApi from "../services/AuthApi";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { MainNav } from "../mainComponent/mainNav";
import { Wrapper } from "../mainComponent/Wrapper";
import Loader from "../doctor/Dashboard-card/Loader";
import UserLinks from "../doctor/Dashboard-card/partial/uselinks";
import { useRecoilState } from "recoil";
import { setHelperData } from "../recoil/atom/setHelperData";
import { setDoctorId } from "../recoil/atom/setDoctorId";

function ClinicList() {
    const { doctorId, patientId } = useParams()
    const [clinicData, setClinicData] = useState(null)
    const [doctorName, setDoctorName] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [helpersData, setHelpersData] = useRecoilState(setHelperData)
    const [DoctorId, setdoctorId] = useRecoilState(setDoctorId)
    const { getDrInfo } = AuthApi()
    const navigate = useNavigate()

    useEffect(() => {
        doctorData()
    }, []);

    function doctorData() {
        setIsLoading(true);
        const doctorId = DoctorId
        getDrInfo({ doctorId })
            .then((res) => {
                setDoctorName(res.result[0])
                setClinicData(res.result[0].clinicList)
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
    const BookAppointments = (clinicData, e) => {
        e.preventDefault();
        navigate(`bookslot/${clinicData._id}`)
    }
    const goBack = () => {
        navigate(-1)
    }
    return (
        <Wrapper>
            <MainNav>
                <div className="clearfix row">
                    <div className="width50">
                        <Link onClick={goBack}>
                            <i className="arrow_back backArrow" title="back button"></i>
                        </Link>
                        <span className='float-none ml-2' style={{ fontSize: 'inherit' }}>Clinic List  </span>
                    </div>
                </div>
            </MainNav>
            <div className=' row'>
                <div className='width_16'>
                    <div className='dash row'>
                        <UserLinks
                            doctorId={DoctorId}
                            helperId={helpersData._id}
                            accessModule={helpersData.access_module}
                        />
                    </div>
                </div>
                <div className="width_84">
                    <div className="common_box">
                        <div className="white-box p-2">
                            {isLoading ?
                                <div className='loader-container'>
                                    <Loader />
                                </div>
                                :
                                <>
                                    {clinicData && clinicData.length > 0 ?
                                        <div className="margin-Left">
                                            {clinicData && clinicData.map((clinicItem, id) => (
                                                <div  key={clinicItem._id}>
                                                    <div className='row underline mb-3 pb-3'>
                                                        {clinicItem.clinicLogo ?
                                                            <figure className="text-align-left col-sm-3" >
                                                                <img
                                                                    className='clinicLogo borderRadius'
                                                                    src={clinicItem.clinicLogo}
                                                                    alt="Clinic Logo"
                                                                />
                                                            </figure>
                                                            : null}
                                                        <div className="col-sm-6" align='left' >
                                                            <div className="mb-4">
                                                                <div className='font_weight fontS'>{clinicItem.clinicName}
                                                                    <div className="icon-location fontSize color">
                                                                        {clinicItem.address}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-sm-3 text-align-left'>
                                                            <NavLink onClick={(e) => BookAppointments(clinicItem, e)}>
                                                                <button className='btn appColor helperBtn'>Book Appointment</button>
                                                            </NavLink>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        : <div className="clinicHistory mb-3 fontS font-weight" >
                                            Clinics are not available.
                                        </div>
                                    }
                                </>}
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}
export { ClinicList }